// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-add .bg-white {
  padding: 0 !important;
}
.order-add .bg-white .ant-page-header .site-page-header .ant-page-header-ghost {
  padding: 13px 14px !important;
}
.order-add .products-row {
  display: flex;
  gap: 16px;
  overflow-x: auto;
}
.order-add .products-row .products-col {
  flex: 0 0 20%;
  max-width: 20%;
  cursor: pointer;
  position: relative;
}
.order-add .products-row .products-col:hover .preview {
  display: flex;
}
.order-add .products-row .products-col .preview {
  display: none;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 14;
  background-color: rgba(255, 255, 255, 0.5);
}
.order-add .products-row .products-col .show-bonus {
  position: absolute;
  right: 0;
  top: 0;
  background: #283142;
  color: white;
  border-radius: 8px;
  padding: 3px 12px;
}
.order-add .order-item-img {
  width: 100px;
  height: 120px;
}
.order-add .order-item-img img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 8px;
}
.order-add .order-items {
  position: relative;
}
.order-add .order-items .order-info {
  position: --webkit-sticky;
  position: sticky;
  top: 0;
  right: 0;
}
.order-add .order-items .shop-card {
  background-color: var(--background);
}
.order-add .order-items .shop-card .close-order {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}
.order-add .order-items .shop-card .edit-order {
  position: absolute;
  bottom: 10px;
  right: 10px;
}
.order-add .order-items .shop-card .extras-color {
  display: block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
.order-add .order-items .shop-card .extras-text {
  display: block;
  text-align: center;
  min-width: 30px;
  padding: 3px;
  border: 1px solid var(--grey);
  padding: 5px 12px;
}
.order-add .order-items .shop-card .extra-value {
  display: block;
  text-align: center;
  width: 50%;
  padding: 3px;
  border: 1px solid var(--grey);
  padding: 5px 12px;
  margin-bottom: 5px;
}
.order-add .order-items .shop-card .extras-image {
  width: 30px;
  height: 30px;
  object-fit: contain;
}
.order-add .order-items .shop-card .white-space-wrap {
  white-space: normal;
}
.order-add .order-items .ant-card-cover img {
  height: 160px;
  object-fit: contain;
}
.order-add .order-items .additional-price {
  font-weight: normal;
  text-align: right;
  color: var(--subscribe);
  font-size: 12px;
}
.order-add .order-items .product-price {
  margin-top: 6px;
}
.order-add .order-items .shop-total p {
  margin: 0;
}
.order-add .order-detail-info .ant-card-head {
  padding: 0 !important;
}
.order-add .order-detail-info .ant-card-head .ant-card-head-wrapper {
  padding: 0 12px 0 12px !important;
  overflow: hidden;
  box-sizing: border-box;
}
.order-add .order-detail-info .ant-card-head .ant-card-head-wrapper .ant-card-extra {
  width: 30%;
}

.extra-group {
  padding: 10px 0;
}

.extras-select .extras-color-wrapper {
  display: block;
  padding: 3px;
  border-radius: 50%;
  border: 1px solid var(--grey);
  cursor: pointer;
}
.extras-select .extras-color-wrapper .extras-color {
  display: block;
  width: 30px;
  height: 30px;
  border-radius: 50%;
}
.extras-select .extras-color-wrapper.selected {
  border-color: var(--dark);
}
.extras-select .extras-text {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
  padding: 3px;
  border: 1px solid var(--grey);
  cursor: pointer;
}
.extras-select .extras-text.selected {
  border-color: var(--dark);
}
.extras-select .extras-image {
  display: block;
  width: 40px;
  height: 40px;
  padding: 3px;
  object-fit: contain;
  border: 1px solid var(--grey);
  cursor: pointer;
}
.extras-select .extras-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.extras-select .extras-image.selected {
  border-color: var(--dark);
}

.strike {
  text-decoration: line-through;
}

[data-theme=dark] .order-add .products-row .ant-card-bordered .ant-card-cover {
  margin: 0;
}
[data-theme=dark] .order-add .products-row .products-col {
  overflow: hidden;
  padding: 10px;
}
[data-theme=dark] .order-add .products-row .products-col .preview {
  background-color: rgba(27, 37, 49, 0.5);
  border-radius: 0.625rem;
}
[data-theme=dark] .order-add .order-items .shop-card {
  background-color: rgb(50, 61, 82);
}
[data-theme=dark] .extras-select .extras-text,
[data-theme=dark] .extras-select .extras-color-wrapper,
[data-theme=dark] .extras-select .extras-image {
  border-color: var(--dark-grey);
}
[data-theme=dark] .extras-select .extras-text.selected,
[data-theme=dark] .extras-select .extras-color-wrapper.selected,
[data-theme=dark] .extras-select .extras-image.selected {
  border-color: var(--light-text);
}
[data-theme=dark] .order-preview .ant-card.ant-card-bordered {
  background-color: var(--dark-background);
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/page/order-add.scss"],"names":[],"mappings":"AACE;EACE,qBAAA;AAAJ;AAEI;EACE,6BAAA;AAAN;AAIE;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AAFJ;AAGI;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AADN;AAGQ;EACE,aAAA;AADV;AAIM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,0CAAA;AAFR;AAIM;EACE,kBAAA;EACA,QAAA;EACA,MAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAFR;AAOE;EACE,YAAA;EACA,aAAA;AALJ;AAMI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AAJN;AAQE;EACE,kBAAA;AANJ;AAOI;EACE,yBAAA;EACA,gBAAA;EACA,MAAA;EACA,QAAA;AALN;AAOI;EACE,mCAAA;AALN;AAMM;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;AAJR;AAMM;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AAJR;AAMM;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAJR;AAMM;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,6BAAA;EACA,iBAAA;AAJR;AAMM;EACE,cAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;AAJR;AAMM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAJR;AAMM;EACE,mBAAA;AAJR;AAQM;EACE,aAAA;EACA,mBAAA;AANR;AASI;EACE,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,eAAA;AAPN;AASI;EACE,eAAA;AAPN;AAUM;EACE,SAAA;AARR;AAcI;EACE,qBAAA;AAZN;AAcM;EACE,iCAAA;EACA,gBAAA;EACA,sBAAA;AAZR;AAaQ;EACE,UAAA;AAXV;;AAkBA;EACE,eAAA;AAfF;;AAkBE;EACE,cAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;AAfJ;AAgBI;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAdN;AAgBI;EACE,yBAAA;AAdN;AAiBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,6BAAA;EACA,eAAA;AAfJ;AAgBI;EACE,yBAAA;AAdN;AAiBE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;AAfJ;AAgBI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAdN;AAgBI;EACE,yBAAA;AAdN;;AAkBA;EACE,6BAAA;AAfF;;AAsBQ;EACE,SAAA;AAnBV;AAsBM;EACE,gBAAA;EACA,aAAA;AApBR;AAqBQ;EACE,uCAAA;EACA,uBAAA;AAnBV;AAwBM;EACE,iCAAA;AAtBR;AA2BI;;;EAGE,8BAAA;AAzBN;AA0BM;;;EACE,+BAAA;AAtBR;AA2BI;EACE,wCAAA;AAzBN","sourcesContent":[".order-add {\n  .bg-white {\n    padding: 0 !important;\n\n    .ant-page-header .site-page-header .ant-page-header-ghost {\n      padding: 13px 14px !important;\n    }\n  }\n\n  .products-row {\n    display: flex;\n    gap: 16px;\n    overflow-x: auto;\n    .products-col {\n      flex: 0 0 20%;\n      max-width: 20%;\n      cursor: pointer;\n      position: relative;\n      &:hover {\n        .preview {\n          display: flex;\n        }\n      }\n      .preview {\n        display: none;\n        justify-content: center;\n        align-items: center;\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        top: 0;\n        left: 0;\n        z-index: 14;\n        background-color: rgba($color: #fff, $alpha: 0.5);\n      }\n      .show-bonus {\n        position: absolute;\n        right: 0;\n        top: 0;\n        background: #283142;\n        color: white;\n        border-radius: 8px;\n        padding: 3px 12px;\n      }\n    }\n  }\n\n  .order-item-img {\n    width: 100px;\n    height: 120px;\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: contain;\n      border-radius: 8px;\n    }\n  }\n\n  .order-items {\n    position: relative;\n    .order-info {\n      position: --webkit-sticky;\n      position: sticky;\n      top: 0;\n      right: 0;\n    }\n    .shop-card {\n      background-color: var(--background);\n      .close-order {\n        position: absolute;\n        top: 10px;\n        right: 10px;\n        cursor: pointer;\n      }\n      .edit-order {\n        position: absolute;\n        bottom: 10px;\n        right: 10px;\n      }\n      .extras-color {\n        display: block;\n        width: 20px;\n        height: 20px;\n        border-radius: 50%;\n      }\n      .extras-text {\n        display: block;\n        text-align: center;\n        min-width:30px;\n        padding: 3px;\n        border: 1px solid var(--grey);\n        padding: 5px 12px;\n      }\n      .extra-value {\n        display: block;\n        text-align: center;\n        width: 50%;\n        padding: 3px;\n        border: 1px solid var(--grey);\n        padding: 5px 12px;\n        margin-bottom: 5px;\n      }\n      .extras-image {\n        width: 30px;\n        height: 30px;\n        object-fit: contain;\n      }\n      .white-space-wrap {\n        white-space: normal;\n      }\n    }\n    .ant-card-cover {\n      img {\n        height: 160px;\n        object-fit: contain;\n      }\n    }\n    .additional-price {\n      font-weight: normal;\n      text-align: right;\n      color: var(--subscribe);\n      font-size: 12px;\n    }\n    .product-price {\n      margin-top: 6px;\n    }\n    .shop-total {\n      p {\n        margin: 0;\n      }\n    }\n  }\n\n  .order-detail-info {\n    .ant-card-head {\n      padding: 0 !important;\n\n      .ant-card-head-wrapper {\n        padding: 0 12px 0 12px !important;\n        overflow: hidden;\n        box-sizing: border-box;\n        .ant-card-extra {\n          width: 30%;\n        }\n      }\n    }\n  }\n}\n\n.extra-group {\n  padding: 10px 0;\n}\n.extras-select {\n  .extras-color-wrapper {\n    display: block;\n    padding: 3px;\n    border-radius: 50%;\n    border: 1px solid var(--grey);\n    cursor: pointer;\n    .extras-color {\n      display: block;\n      width: 30px;\n      height: 30px;\n      border-radius: 50%;\n    }\n    &.selected {\n      border-color: var(--dark);\n    }\n  }\n  .extras-text {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 40px;\n    height: 40px;\n    padding: 3px;\n    border: 1px solid var(--grey);\n    cursor: pointer;\n    &.selected {\n      border-color: var(--dark);\n    }\n  }\n  .extras-image {\n    display: block;\n    width: 40px;\n    height: 40px;\n    padding: 3px;\n    object-fit: contain;\n    border: 1px solid var(--grey);\n    cursor: pointer;\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: contain;\n    }\n    &.selected {\n      border-color: var(--dark);\n    }\n  }\n}\n.strike {\n  text-decoration: line-through;\n}\n\n[data-theme='dark'] {\n  .order-add {\n    .products-row {\n      .ant-card-bordered {\n        .ant-card-cover {\n          margin: 0;\n        }\n      }\n      .products-col {\n        overflow: hidden;\n        padding: 10px;\n        .preview {\n          background-color: rgba($color: #1b2531, $alpha: 0.5);\n          border-radius: 0.625rem;\n        }\n      }\n    }\n    .order-items {\n      .shop-card {\n        background-color: rgb(50, 61, 82);\n      }\n    }\n  }\n  .extras-select {\n    .extras-text,\n    .extras-color-wrapper,\n    .extras-image {\n      border-color: var(--dark-grey);\n      &.selected {\n        border-color: var(--light-text);\n      }\n    }\n  }\n  .order-preview {\n    .ant-card.ant-card-bordered {\n      background-color: var(--dark-background);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
